<template>
  <div class="orphan-admin-container">
    <div class="orphan-admin-card">
      <div class="orphan-admin-icon">
        <i class="fas fa-lock"></i>
      </div>
      <h2 class="orphan-admin-title">Erişim Yetkiniz Bulunmuyor</h2>
      <p class="orphan-admin-message">
        Hesabınıza bağlı yetki tanımı bulunamadı. Lütfen sistem yöneticinizle iletişime geçin.
      </p>
      <a-button type="default" @click="logout">
        Çıkış Yap
      </a-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrphanAdmin',

  methods: {
    logout() {
      localStorage.removeItem('access_token')
      localStorage.removeItem('refresh_token')
      this.$router.push('/login')
    },
  },
}
</script>

<style scoped>
.orphan-admin-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #f0f2f5;
}

.orphan-admin-card {
  text-align: center;
  background: #fff;
  border-radius: 8px;
  padding: 48px 40px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  max-width: 400px;
  width: 100%;
}

.orphan-admin-icon {
  font-size: 48px;
  color: #faad14;
  margin-bottom: 24px;
}

.orphan-admin-title {
  font-size: 20px;
  font-weight: 600;
  color: #262626;
  margin-bottom: 12px;
}

.orphan-admin-message {
  font-size: 14px;
  color: #595959;
  margin-bottom: 32px;
  line-height: 1.6;
}
</style>
